module.exports = __webpack_public_path__ + "static/media/slider_bg_mob_3.2c154d8a.jpg";